var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_76","data-name":"Group 76","transform":"translate(-13892.716 -4312.46)"},[React.createElement("line",{"id":"Line_143","data-name":"Line 143","x1":"29.947","y2":"29.947","transform":"translate(13893.231 4312.975)","fill":"none","stroke":"currentColor","strokeMiterlimit":"10","strokeWidth":"1.457","key":0}),React.createElement("line",{"id":"Line_144","data-name":"Line 144","x2":"29.947","y2":"29.947","transform":"translate(13893.231 4312.975)","fill":"none","stroke":"currentColor","strokeMiterlimit":"10","strokeWidth":"1.457","key":1})]));
}

CloseInline.defaultProps = {"width":"30.978","height":"30.978","viewBox":"0 0 30.978 30.978"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
